<template>
  <section id="ConfirmInformationForm">
    <div class="text-center mb-3">
      <img
        alt
        :src="$storeIndex.getImageGobalAssets('authorization/logo-goship-gosell')"
        class="logo-goship-gosell"
      >
    </div>
    <div
      class="text-center mb-3 h3 pt-2"
      v-if="this.registerType == 'socialRegister'"
    >
      {{ $t('Confirm Information') }}
    </div>
    <div
      class="form-group form-group-feedback form-group-feedback-left"
      :class="{ 'form-group-error': $v.form.fullname.$error }"
    >
      <input
        type="text"
        class="form-control"
        :disabled="fullNameDisabled"
        :placeholder="$t('Full Name')"
        v-model.trim.lazy="$v.form.fullname.$model"
        @keyup="realtime($event, 'fullname')"
        @paste="realtime($event, 'fullname')"
        @blur="realtime($event, 'fullname')"
      >
      <div class="form-control-feedback">
        <i class="fa-user-check far text-muted" />
      </div>
      <div
        v-if="!$v.form.fullname.required"
        class="validation-invalid-label"
      >
        {{ $t("Please enter fullname") }}.
      </div>
      <div
        v-else-if="!$v.form.fullname.minLength"
        class="validation-invalid-label"
      >
        {{
          $t("Name must have at least") +
            " " +
            $v.form.fullname.$params.minLength.min +
            " " +
            $t("letters.")
        }}
      </div>
    </div>
    <div
      class="form-group form-group-feedback form-group-feedback-left"
      :class="{ 'form-group-error': $v.form.telephone.$error }"
    >
      <input
        type="text"
        class="form-control"
        :disabled="phoneDisabled"
        :placeholder="$t('Phone')"
        v-model.trim.lazy="$v.form.telephone.$model"
      >
      <div class="form-control-feedback">
        <i class="fa-mobile-alt fas text-muted" />
      </div>
      <div
        v-if="!$v.form.telephone.required"
        class="validation-invalid-label"
      >
        {{ $t("Please enter telephone.") }}
      </div>
      <div
        v-else-if="!$v.form.telephone.numeric"
        class="validation-invalid-label"
      >
        {{ $t("Telephone must be only numeric.") }}
      </div>
      <div
        v-else-if="!$v.form.telephone.checkIsValidPhoneNumber"
        class="validation-invalid-label"
      >
        {{ $t("Invalid telephone format") }}
      </div>
      <div
        v-else-if="!$v.form.telephone.isUniquePhoneNumber"
        class="validation-invalid-label"
      >
        {{ $t("This telephone already registered.") }}
      </div>
    </div>
    <div 
      class="form-group form-group-feedback form-group-feedback-left"
      :class="{ 'form-group-error': $v.form.email.$error }"
    >
      <input
        type="email"
        class="form-control"
        :disabled="emailDisabled"
        :placeholder="$t('Email')"
        v-model.trim.lazy="$v.form.email.$model"
      >
      <div class="form-control-feedback">
        <i class="fa-at far text-muted" />
      </div>
      <div
        v-if="!$v.form.email.required"
        class="validation-invalid-label"
      >
        {{ $t("Please enter email.") }}
      </div>
      <div
        v-else-if="!$v.form.email.email"
        class="validation-invalid-label"
      >
        {{ $t("Email invalid") }}
      </div>
      <div
        v-else-if="!$v.form.email.isRegisteredEmail"
        class="validation-invalid-label"
      >
        {{ $t(messageEmail) }}
      </div>
    </div>
    <div
      class="form-group form-group-feedback form-group-feedback-left"
      :class="{
        'form-group-error': $v.form.couponReferCode.$invalid,
      }"
    >
      <input
        type="text"
        class="form-control"
        :placeholder="$t('Refer Code/Coupon Code')"
        @input="$v.form.couponReferCode.$touch"
        v-model.trim="$v.form.couponReferCode.$model"
        @keyup="realtime($event,'couponReferCode')"
      >
      <div class="form-control-feedback">
        <i class="fa-solid fa-ticket text-muted" />
      </div>
      <div
        v-if="!$v.form.couponReferCode.isReferCode && errorMessageReferCode != ''"
        class="validation-invalid-label"
      >
        {{ $t(errorMessageReferCode) }}
      </div>
    </div>
    <div class="form-group f-14">
      <p class="text-muted">
        {{ $t("By signing up a new account,") }}
      </p>
      <div class="d-flex">
        <div class="pl-4 custom-checkbox custom-control-inline mr-0">
          <input
            type="checkbox" 
            class="custom-control-input" 
            id="agree-term-policy"
            :checked="agreeTermPolicy"
            @change="() => agreeTermPolicy = !agreeTermPolicy"
          >
          <label
            class="custom-control-label"
            for="agree-term-policy"
          /> 
        </div>
        <p class="text-muted">
          <span class="text-muted">{{ $t("I have agree to") }}
            <a
              :href="urlPolicy"
              target="_back"
            >
              {{ $t("Terms of Services and Privacy Policy.") }}
            </a>
          </span>
        </p>
      </div>
    </div>
    <div
      class="form-group"
      id="btnRegister"
    >
      <ladda
        text="Confirm"
        :btn-class="'btn btn-primary btn-block'"
        :loading="loading"
        :disabled="$v.validationGroup.$invalid"
        @click="confirmRegisterSocial()"
      />
      <a :href="$router.resolve({name: 'auth.register'}).href">
        <button 
          class="btn mt-3 btn-light btn-block"
          type="button"
        >
          {{ $t('Cancel') }}
        </button>
      </a>
    </div>
    <div>
      <div class="form-group mb-0">
        <div class="btn-group-justified">
          <ul
            class="m-auto navbar-nav"
            style="width: 125px"
          >
            <li class="nav-item dropdown language-switch">
              <a
                class="navbar-nav-link dropdown-toggle"
                data-toggle="dropdown"
              >
                <img
                  :src="
                    $storeIndex.getImageSrc('lang/' + lang)
                  "
                  class="img-flag mr-2"
                  alt=""
                >
                {{ $t(title) }}
              </a>
              <div class="dropdown-menu">
                <a
                  v-for="(value, key) in localList"
                  :name="key"
                  :key="`lang-${key}`"
                  @click="selectLang(key)"
                  href="javascript:void(0);"
                  class="dropdown-item english"
                >
                  <img
                    :src="
                      $storeIndex.getImageSrc(
                        'lang/' + key
                      )
                    "
                    class="img-flag"
                    alt=""
                  >
                  {{ $t(value) }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import CentralApi from "@/services/endpoint/central.service";
import { isValidPhoneNumber } from "libphonenumber-js";
import {
    required,
    minLength,
    maxLength,
    sameAs,
    email,
    numeric,
} from "vuelidate/lib/validators";
import Ladda from "@/plugins/Ladda.vue";
import { localSave, localRead } from "@/store/lang";
const checkIsValidPhoneNumber = (phoneNumber) => isValidPhoneNumber(phoneNumber, "TH");
export default {
  name: "ConfirmInformationForm",
  components: {
    Ladda
  },
  props: {
    registerType: {
      default: null,
      type: String
    },
    socialUser:{
      default:null,
      type:Object
    }
  },
  data() {
    return {
      loading: false,
      fullNameDisabled: false,
      phoneDisabled: false,
      emailDisabled: false,
      lang: localRead("local"),
      localList: {
          th: "Thai",
          en: "English",
      },
      form: {
        fullname: "",
        telephone: "",
        email: "",
        couponReferCode: "",
        agreeTerms: false,
      },
      messageEmail: "",
      errorMessageReferCode: "",
      mailValidGroupClass: "form-group-success",
      urlPolicy: process.env.GOSHIP_URL + "/service-condition",
      agreeTermPolicy: false
    }
  },
  computed: {
    title() {
      return this.localList[this.lang];
    },
  },
  mounted() {
    if (this.$route.query.ref) {
      localSave("ref", this.$route.query.ref);
    }
    if (this.$route.query.mcode) {
      localSave("mcode", this.$route.query.mcode);
    }
    if (this.$route.query.utm_source) {
      localSave("utm_source", this.$route.query.utm_source);
    }
    if (this.$route.query.utm_medium) {
      localSave("utm_medium", this.$route.query.utm_medium);
    }
    if (this.$route.query.utm_campaign) {
      localSave("utm_campaign", this.$route.query.utm_campaign);
    }
    if (this.$route.query.utm_referer) {
      localSave("utm_referer", this.$route.query.utm_referer);
    }
    if (this.$route.query.utm_adsid) {
      localSave("utm_adsid", this.$route.query.utm_adsid);
    }
    if (this.$route.query.uuid) {
      localSave("uuid", this.$route.query.uuid);
    }
    if (this.$route.query.refer) {
      localSave("refer", this.$route.query.refer);
    }
    if(typeof this.$route.query.mcode === 'undefined' && typeof this.$route.query.uuid === 'undefined'){
      this.form.couponReferCode = localRead("refer");
    }
    // check provider
    if (this.socialUser.provider == 'google') {
      this.form.fullname = this.getKeywordWithOutSpacialKey(this.socialUser.name);
      this.form.email = this.socialUser.email;
      this.emailDisabled = this.form.email ? true : false;
    }
    if (this.socialUser.provider == 'facebook') {
      this.form.fullname = this.getKeywordWithOutSpacialKey(this.socialUser.name);
      this.form.email = this.socialUser.email;
      this.emailDisabled = this.form.email ? true : false;
    }
    if (this.socialUser.provider == 'line') {
      this.form.fullname = this.getKeywordWithOutSpacialKey(this.socialUser.name);
      this.form.email = this.socialUser.email;
      this.emailDisabled = this.form.email ? true : false;
    }
    if (this.socialUser.provider == 'apple') {
      this.form.email = null;
      this.emailDisabled = this.form.email ? true : false;
    }
    
    if(this.form.email) this.$v.form.email.$touch()
  },
  methods: {
    realtime: function(event,key){
      if(key == 'fullname'){
        var illegalChars = /[^A-Za-zก-ฮ\เ\แ\า\ๆ\ไ\ใ\โ\ๅ\ิ\ื\์\้\็\่\๋\๊\ี\ั\ํ\ุ\ู\ึ\๐ฺ\๐\ะ\ำ ]/gi;
        var illegalCharsOrMultipleSpaces = /[^A-Za-zก-ฮ\เ\แ\า\ๆ\ไ\ใ\โ\ๅ\ิ\ื\์\้\็\่\๋\๊\ี\ั\ํ\ุ\ู\ึ\๐ฺ\๐\ะ\ำ ]|\s\s/gi;
        if(event.target.value.search(illegalCharsOrMultipleSpaces) > -1) {
          this.$v.form[key].$model = event.target.value.replace(illegalChars, "").replace(/\s+/g, " ");
          return;
        }
      }
      this.$v.form[key].$model = event.target.value;
    },
    getKeywordWithOutSpacialKey(keyWords) {
      let illegalChars = /[^A-Za-zก-ฮ\เ\แ\า\ๆ\ไ\ใ\โ\ๅ\ิ\ื\์\้\็\่\๋\๊\ี\ั\ํ\ุ\ู\ึ\๐ฺ\๐\ะ\ำ ]/gi;
      let illegalCharsOrMultipleSpaces = /[^A-Za-zก-ฮ\เ\แ\า\ๆ\ไ\ใ\โ\ๅ\ิ\ื\์\้\็\่\๋\๊\ี\ั\ํ\ุ\ู\ึ\๐ฺ\๐\ะ\ำ ]|\s\s/gi;
      if(keyWords.search(illegalCharsOrMultipleSpaces) > -1) {
        return keyWords.replace(illegalChars, "").replace(/\s+/g, " ");
      }
      return keyWords;
    },
    selectLang(lang) {
      localSave("local", lang);
      this.lang = lang;
      this.$i18n.locale = lang;
      // location.reload();
    },
    async confirmRegisterSocial() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          first_name: this.$v.form.fullname.$model,
          last_name: this.$v.form.fullname.$model,
          email: this.$v.form.email.$model,
          mobile: this.$v.form.telephone.$model,
          coupon: this.$v.form.couponReferCode.$model,
          ref: localRead("ref"),
          mcode: localRead("mcode"),
          uuid: localRead("uuid"),
          utm_source: localRead("utm_source"),
          utm_medium: localRead("utm_medium"),
          utm_campaign: localRead("utm_campaign"),
          utm_referer: localRead("utm_referer"),
          utm_adsid: localRead("utm_adsid"),
          socialLogin: this.registerType === "socialRegister" ? this.socialUser : null,
          socialLoginStateWebsocket: this.registerType === "socialRegister" ? localStorage.getItem("SocialLoginStateWebsocket") : null
        };
        if(localRead("ref")) {
          data['ref'] = localRead("ref");
        }
        if(localRead("utm_source")) {
          data['utm_source'] = localRead("utm_source");
        }
        if(localRead("utm_medium")) {
          data['utm_medium'] = localRead("utm_medium");
        }
        if(localRead("utm_campaign")) {
          data['utm_campaign'] = localRead("utm_campaign");
        }
        if(localRead("utm_referer")) {
          data['utm_referer'] = localRead("utm_referer");
        }
        if(localRead("utm_adsid")) {
          data['utm_adsid'] = localRead("utm_adsid");
        }
        if(localRead("uuid")) {
          data['uuid'] = localRead("uuid");
        }
        this.loading = true;
        this.$forceUpdate();
        await this.$store.dispatch('auth/register', data).then((response) => {
          if (this.socialUser.provider == 'apple') {
            localStorage.removeItem("SocialLoginStateWebsocket");
            window.location.href = process.env.CENTRAL_ACC_URL + '/login';
          } else {
            localStorage.removeItem("SocialLoginStateWebsocket");
            window.close();
          }
        })
        this.loading = false;
      }
    }
  },
  validations: {
    form: {
      fullname: {
        required,
        minLength: minLength(4),
      },
      telephone: {
        required,
        numeric,
        checkIsValidPhoneNumber,
        async isUniquePhoneNumber(phoneNumber) {
          if (
            phoneNumber === "" ||
            this.$v.form.telephone.checkIsValidPhoneNumber === false
          )
          return true;
          const res = await CentralApi.Auth.isUniquePhoneNumber(
            phoneNumber
          );
          let data = res.data.registered;
          return data;
        },
      },
      email: {
        required,
        email,
        async isRegisteredEmail(emailAddress) {
          if (
            emailAddress === "" ||
            this.$v.form.email.email === false
          )
          return true;
          const res = await CentralApi.Auth.isEmailValid(
            emailAddress
          );
          let data = res.data;
          if (data.valid !== true) {
            this.messageEmail = data.message;
            this.mailValidGroupClass = "form-group-error"
            return data.valid;
          }
          return data.valid;
        },
      },
      couponReferCode: {
        async isReferCode(referCode) {
          this.errorMessageReferCode = "";
          if (referCode !== "" ){
            const res = await CentralApi.Auth.getCheckCoupon('?coupon='+referCode);
            if (!res.data.status) {
              if (res.data.message == "Invalid coupon code.") {
                this.errorMessageReferCode = "Coupon not fount, please re-type again."
              } else {
                this.errorMessageReferCode = "This discount code has reached the required number of users."
              }
            }
            return res.data.status
          }
          return true;
        },
      },
      policy : {
        agreeTermPolicy() {
          return this.agreeTermPolicy
        }
      }
    },
    validationGroup: [
      "form.fullname",
      "form.telephone",
      "form.email",
      "form.couponReferCode",
      "form.policy"
  ],
  }
}
</script>
<style scoped>
  input[type="email"],
  input[type="text"],
  input[type="password"] {
      font-family: "Sarabun", sans-serif;
  }
  div.validation-invalid-label {
    display: none !important;
  }
  div.form-group-error > div.validation-invalid-label {
    display: block !important;
  }
  div.form-group-success > div.validation-invalid-label {
    display: none !important;
  }

  .text-size-13 {
    font-size: 13px !important;
  }

  #generate .btn.btn-outline:hover {
    color: #333 !important;
    background-color: #fafafa;
    border-color: #ddd;
  }

  .icon-mark-1 {
    left: auto;
    right: 0px;
    font-size: 13px;
  }

  .icon-mark-2 {
    left: auto;
    right: 22px;
    margin-top: -0.7%;
  }

  .valid-password {
    display: block;
    margin: 0px;
    max-width: 100% !important;
    width: max-content !important;
    bottom: 42px;
    top: auto;
    right: auto;
    left: 355px;
    bottom: -73px;
    z-index: 101;
  }

  .valid-arrow {
    top: 50%;
    margin-top: -2.5px;
  }

  .custom-control-label::after, .custom-control-label::before { 
    width: 1rem;
    height: 1rem;
    left: -1.75rem;
    top: 0.15rem;
    border-color: #455964 !important;
  }

  .f-14 {
    font-size: 14px;
  }

  @media only screen and (max-width: 881px) {
    .valid-password {
      top: auto;
      right: auto;
      left: auto;
      bottom: 45px;
      max-width: 100% !important;
    }
    .valid-arrow {
      top: auto;
      margin-top: 0px;
      left: 45%;
      margin-left: -2.5px;
    }
    .bs-popover-auto[x-placement^=right]>.arrow, .bs-popover-right>.arrow {
      bottom: calc((0.375rem + 1px) * -1);
      width: 0.75rem;
      height: 0.375rem;
      margin: 0 0.25rem;
    }
    .bs-popover-auto[x-placement^=right]>.arrow::before, .bs-popover-right>.arrow::before {
      bottom: 0;
      border-width: 0.375rem 0.375rem 0;
      border-top-color: rgba(0,0,0,.2);
      left: 10%;
      border-right-color: rgb(0 0 0 / 0%);
    }
    .bs-popover-auto[x-placement^=right]>.arrow::after, .bs-popover-right>.arrow::after {
      bottom: 1px;
      border-width: 0.375rem 0.375rem 0;
      border-top-color: #fff;
      border-right-color: rgb(0 0 0 / 0%);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/central/authorization/ConfirmInformation.vue